import config from 'constants/config'
import { LUX_PLUS_EXCLUDED_REGIONS } from 'constants/config/region'

/**
 * Stateless check for whether LuxPlus+ is available in a given region.
 *
 * `regionCode` is normalised to upper case so callers may pass either casing
 * (`LUX_PLUS_EXCLUDED_REGIONS` is upper case).
 */
export const getIsLuxPlusEnabledForRegion = (regionCode: string): boolean => !!(
  config.LUXURY_PLUS_ENABLED &&
  !LUX_PLUS_EXCLUDED_REGIONS.includes(regionCode.toUpperCase())
)
